
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.328","height":"15.329"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('path',{staticClass:"a",attrs:{"d":"M0 6.665S3.332 0 9.164 0s9.164 6.665 9.164 6.665S15 13.329 9.164 13.329 0 6.665 0 6.665z"}}),_c('circle',{staticClass:"a",attrs:{"cx":"2.5","cy":"2.5","r":"2.5","transform":"translate(7 3.93)"}})])])
          )
        }
      }
    